// Comparador canónico para listas de logs (Recent Logs, biblioteca, exports).
//
// El orden histórico era puramente por timecode (`tc`). Desde que Recent Logs
// permite reordenar a mano, los logs pueden traer `sortOrder` (persistido en
// DB vía content.sort_order). Reglas:
//   1. Ambos con sortOrder → gana sortOrder (empate → tc).
//   2. Sólo uno con sortOrder → el ordenado a mano va primero; los logs nuevos
//      (sin sortOrder) se acumulan después, entre ellos por tc.
//   3. Ninguno con sortOrder → tc, exactamente el comportamiento anterior.

interface OrderableLog {
  tc?: string;
  sortOrder?: number;
}

export function compareLogs(a: OrderableLog, b: OrderableLog): number {
  const ao = typeof a?.sortOrder === "number" ? a.sortOrder : null;
  const bo = typeof b?.sortOrder === "number" ? b.sortOrder : null;
  if (ao !== null && bo !== null) {
    if (ao !== bo) return ao - bo;
  } else if (ao !== null) {
    return -1;
  } else if (bo !== null) {
    return 1;
  }
  return (a?.tc ?? "").localeCompare(b?.tc ?? "");
}
